(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyRangeSpinnerCta", [
    "$window",
    "$analytics",

    function ($window, $analytics) {
      var controller = function () {
        var ctl = this;

        ctl.triggerCtaClickAnalyticsEvent = function (url) {
          $window.location.href = url;
        };

        ctl.triggerSecondaryCtaClickAnalyticsEvent = function (url, text) {
          var analyticsData = {
            click_text: text,
            click_type: "button",
            link_url: url,
            module_name: null,
            element_name: null,
          };

          $analytics.eventTrack("click_secondary_interaction", analyticsData);
        };
      };

      return {
        bindToController: {
          tyRangeSpinnerCtaGoalId: "@tyRangeSpinnerCtaGoalId",
        },
        controller: controller,
        controllerAs: "tyRangeSpinnerCta",
        restrict: "A",
        scope: true,
      };
    },
  ]);
})(window.angular);
